module.exports = __webpack_public_path__ + "img/li4.25872e73.png";